import React, { useState } from 'react';
import AdSpaceSubscriptionPlansAdminList from './components/SubscriptionPlansAdminList';
import AdSpaceSubscriptionPlansAdminAddSubscriptionPlanPage from './components/SubscriptionPlansAdminAddSubscriptionPlanPage';
import { Box, Tabs, Tab } from '@mui/material';



const AdSpaceSubscriptionPlansAdminPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="AdSpaces admin tabs">
        <Tab label="List Subscription Plans" />
        <Tab label="Insert Subscription Plan" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <AdSpaceSubscriptionPlansAdminList />}
        {tab === 1 && <AdSpaceSubscriptionPlansAdminAddSubscriptionPlanPage />}
      </Box>
    </Box>
  );
};

export default AdSpaceSubscriptionPlansAdminPage;